import './menu.css'
import Sidebar from "./sidebar/sidebar";
import logo from '../../assets/navbar/Looogo.png'
// import cart from '../../assets/navbar/shopping-cart.png'
import {useState} from "react";
import Modal from "./modal/modal";
import {Dishes} from "../../DataBase/data";
import {Other} from '../../DataBase/data'
import Salads from "./components/salads/salads";
import Soups from "./components/soups/soups";
import Meals from "./components/meals/meals";
import Mangal from "./components/mangal/mangal";
import Asarti from "./components/asarti/asarti";
import Sweets from "./components/sweets/sweets";
import Drinks from "./components/drinks/drinks";
import Tea from "./components/tea/tea";
import Coffee from "./components/coffee/coffee";
import Fresh from "./components/fresh/fresh";
import Smooth from "./components/smooth/smooth";
import Sheyk from "./components/sheyk/sheyk";
import Drinkss from './components/drinkss/Drinks'
import ScrollToTop from "../scroll/scroll";

const Menu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('')
    const [currItemIdx, setCurrItemIdx] = useState(0);

    const toggle = (itemId) => {
        setCurrItemIdx(itemId);
        setIsOpen(p => !p);
    }

    const Search = (e) => {
        setSearch(e.target.value)

    }

    return (
        <div className={'menu'}>
            <div className="menu_header">
                <div className="color_menu_header">
                    <div className={'menu_header_logo'}>
                        <a href="/"> <img src={logo} alt=""/></a>
                    </div>
                    {/*<div className="menu_header_search">*/}
                    {/*    <input type="text" placeholder={'Қидириш...'} onChange={Search}/>*/}
                    {/*</div>*/}
                </div>
            </div>
            <Sidebar/>
            <div className="menu_content">
                <div className="menu_content_block">
                    <Salads dishes={Dishes} s={search}/>
                    <Soups dishes={Dishes} s={search}/>
                    <Meals dishes={Dishes} s={search}/>
                    <Mangal dishes={Dishes} s={search}/>
                    <Asarti dishes={Dishes} s={search}/>
                    <Sweets dishes={Dishes} s={search}/>
                    <Tea dishes={Dishes} s={search}/>
                    <Coffee dishes={Dishes} s={search}/>
                    <Drinks dishes={Dishes} s={search}/>
                    <Fresh dishes={Dishes} s={search}/>
                    <Smooth dishes={Dishes} s={search}/>
                    <Sheyk dishes={Dishes} s={search}/>
                    <Drinkss other={Other} s={search}/>
                    <ScrollToTop showBelow={250}/>
                </div>
                <Modal isopen={isOpen} toggle={toggle} item={Dishes[currItemIdx]}/>
            </div>
        </div>
    )
}
export default Menu
